import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import ApiOptionsConfig from './api-options.config';
import { ApiBaseService } from './api-base.service';

const BASE_URL = '/introducers';
const REVENUES_URL = '/introducer-revenues';
const CLIENTS_URL = '/introducer-clients';

@Injectable({
  providedIn: 'root',
})
export class IntroducersService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(introducerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${introducerId}`), options?.params);
  }

  create(formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(BASE_URL), formData);
  }

  update(introducerId: number, formData: FormData): Observable<any> {
    return this.PUTMULTIPART(this.getUrl(`${BASE_URL}/${introducerId}`), formData);
  }

  delete(introducerId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${introducerId}`));
  }

  deleteContract(introducerId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${introducerId}/contract`));
  }

  listRevenues(introducerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${introducerId}/revenues`), options?.params);
  }

  detailRevenues(introducerId: number, introducerRevenueId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${introducerId}/revenues/${introducerRevenueId}`), options?.params);
  }

  createRevenues(introducerId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${introducerId}/revenues`), data);
  }

  updateRevenues(introducerId: number, introducerRevenueId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${introducerId}/revenues/${introducerRevenueId}`), data);
  }

  deleteRevenues(introducerId: number, introducerRevenueId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${introducerId}/revenues/${introducerRevenueId}`));
  }

  listIntroducerRevenues(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(REVENUES_URL), options?.params);
  }

  introducerRevenueTotals(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${REVENUES_URL}/totals`), options?.params);
  }

  listIntroducerClients(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(CLIENTS_URL), options?.params);
  }
}
